<span
  class="or-button or-status-icon or-iconic"
  [class.or-primary]="primary()"
  [ngClass]="healthStatusClasses()"
  [matTooltip]="healthStatusTitle()"
  matTooltipClass="health-tooltip"
  matTooltipPosition="above"
  [attr.data-cy]="dataCy()"
  [attr.data-test]="dataTest()">
</span>
